import { useEffect, useState } from 'react';

/** 1x up to a 768px-wide viewport, growing ~linearly to 1.8x at 1920px and beyond. */
function dialogScaleFor(width: number): number {
  return Math.min(1.8, Math.max(1, 1 + (width - 768) / 1400));
}

/**
 * Scale factor for floating dialogs laid out for a phone: apply it as CSS `zoom`
 * so desktop popups grow with the screen instead of staying tiny.
 */
export function useDialogScale(): number {
  const [scale, setScale] = useState(() => dialogScaleFor(window.innerWidth));
  useEffect(() => {
    const onResize = () => setScale(dialogScaleFor(window.innerWidth));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return scale;
}
